// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"154":"fdef889f887a5639","542":"95b7c7870673de8e","783":"e45c328ee1029c44","816":"400e63aac2732154","888":"a05bfa11a83cb3cb","960":"89749a1d30de8761"}[chunkId] + ".css";
};